// Import axios to make HTTP requests
import axios from 'axios'
import  messages  from '@/utils/ErrorMessages';
import { notify } from '@kyvg/vue3-notification';

export default {
    namespaced: true,

    state: () => ({
        changeLogs: [],
        loading: false,
    }),
    getters:{
        isLoading(state){
            return state.loading
        },
        allChangeLogs(state){
            return state.changeLogs
        },
        countChanges(state){
            return state.changeLogs.length
        },
        getById: (state) => (id) => {
            return state.changeLogs.find( changeItem => changeItem.id === id )
        },
    },
    mutations: {
        setChangeLogs(state, payload) {
            state.changeLogs = payload
        },
        save(state, payload) {
            state.changeLogs.push(payload)
        },
        remove(state,payload){
            state.changeLogs.splice(state.changeLogs.indexOf(payload),1)
        },
        update(state, payload) {
            const index = state.changeLogs.findIndex(changeItem => changeItem.id === payload.id)
            state.changeLogs.splice(index, 1, payload)
        },
    },

    actions: {
        async fetchChangeLogs({commit}){
            this.loading = true
            await axios.get('/v1/changelogs')
            .then(response => {
                commit('setChangeLogs', response.data.data)
            }).catch(e => {
                console.warn(e.error)
                const errorCode = e?.response?.data?.error || 'ServerError';
                notify({type:'error', title:messages[errorCode].title, text: messages[errorCode].text})
            }).finally(() => {
                this.loading = false
            })
        },
        async addChangeLog({commit}, payload){
            this.loading = true
            await axios.post('/v1/changelogs', payload)
            .then(response => {
                commit('save', response.data.data)
                notify({type:'success', title:'Tudo certo', text: 'Atualização salva com sucesso'})
            }).catch(e => {
                console.warn(e.error)
                const errorCode = e?.response?.data?.error || 'ServerError';
                notify({type:'error', title:messages[errorCode].title, text: messages[errorCode].text})
            }).finally(() => {
                this.loading = false
            })
        },
        async editChangeLog({commit}, payload){
            this.loading = true
            await axios.put(`/v1/changelogs/${payload.id}`, payload)
            .then(response => {
                commit('update', response.data)
                notify({type:'success', title:'Tudo certo', text: 'Conteudo atualizado com Sucesso!'})
            }).catch(e => {
                console.warn(e.error)
                const errorCode = e?.response?.data?.error || 'ServerError';
                notify({type:'error', title:messages[errorCode].title, text: messages[errorCode].text})
            }).finally(() => {
                this.loading = false
            })
        },
        async removeChangeLog({commit}, id){
            this.loading = true
            await axios.delete(`/v1/changelogs/${id}`)
            .then(response => {
                commit('remove', id)
                notify({type:'success', title:'Tudo certo', text: 'Atualização removida com sucesso'})
            }).catch(e => {
                console.warn(e.error)
                const errorCode = e?.response?.data?.error || 'ServerError';
                notify({type:'error', title:messages[errorCode].title, text: messages[errorCode].text})
            }).finally(() => {git
                this.loading = false
            })

        },
    },

};